import {RequestCountryRecord} from './request-country-record';
import {RequestGroup} from './request-group';
import {RequestHystory} from './request-hystory';
import {RequestHistoryAudits, RequestUnifications} from './request-unifications';
import {User} from '../user/user';

export class Request {

    id: string;
    name: string;
    code: string;
    motive: string;
    channelDistribution: string;
    unitMeasure: string;
    description: string;
    recordHolder: string;
    ministryRecord: string;
    dispatchedBy: string;
    recordValidity: Date;
    // Item 2 — pares registro/validade por país. Vazio nas solicitações antigas,
    // que seguem com o valor em ministryRecord/recordValidity (fallback de leitura).
    countryRecords: RequestCountryRecord[];
    manufacturer: string;
    dueDate: number;
    storageTemperature: number;
    storageHumidity: number;
    dueDateRevised: number;
    codeSap: string;
    descriptionFinish: string;
    country: string;
    status: string;
    step: number;
    type: string;
    bulk: boolean;
    ean: string;
    dum: string;
    unificationObservation: string;
    unifications: RequestUnifications[];
    createdAt: Date;
    updatedAt: Date;
    group: RequestGroup[];
    history: RequestHystory[];
    historyAudits: RequestHistoryAudits[];
    createdBy: User;
    countryNotification: string;
    countryNotifications: any[];
    countryAdditional: any[];
    reasonRequest: number;
    molecule: string;
    concentration: string;
    concentrationType: string;
    productBrand: string;
    productBrandType: string;
    commercialPresentation: string;
    stepReprove: number;
    // Item 2 (A2) — calculado pela API no GET /request/{id}. true = a etapa 2 está
    // reservada ao AR Local com cluster de outro país e o usuário logado não é ele.
    // Ausente ou false = comportamento normal (fluxo antigo, país único, PMOINT, admin).
    stepTwoBlockedByCluster: boolean;
    area_400: string;
    countrySolicitationPmoInt: string;
    countryManufacturingPmoInt: string;

    flowType: string;
    centerModel: string;
    channelModel: string;
    reasonRequestInfo: string;
    typeMaterial: string;
    center: string;
    concentrationPrinciple1: string;
    concentrationPrinciple2: string;
    concentrationPrinciple3: string;
    concentrationPrinciple4: string;
    ncm: string;
    taxClassification: string;
    groupCtgs: string;
    materialGroup1: string;
    aprova: string;

    countrySolicitationGenfar: any[];
    countryManufacturingGenfar: string;

    countrySolicitationProductsLatam: string;
    countryManufacturingProductsLatam: string;

    constructor() {
        this.group = [];
        this.history = [];
        this.unifications = [];
        this.countryNotifications = [];
        this.countryAdditional = [];
        this.countrySolicitationGenfar = [];
        this.countryRecords = [];
    }
}
